import styles from './ProjectContent.module.scss';
import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { BASE_URL } from '../../../../requests/BASE_URL';
import MainContainerLeftControl from '../../../universal_components/MainContainerLeftControl/MainContainerLeftControl';
import ProjectContentBlock from './ProjectContentBlock/ProjectContentBlock';
import ProjectEconomyIndicators from './ProjectEconomyIndicators/ProjectEconomyIndicators';
import ProjectPhotos from './ProjectPhotos/ProjectPhotos';
import ProjectDocuments from './ProjectDocuments/ProjectDocuments';
import ProjectTeam from './ProjectTeam/ProjectTeam';
import ProjectsAside from '../ProjectsAside/ProjectsAside';
import classnames from 'classnames';
import { isMobile } from 'react-device-detect';
import ProjectInfo from './ProjectInfo/ProjectInfo';

const ProjectContent = () => {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [detailsRes] = await Promise.all([fetch(`${BASE_URL}projects/${id}`)]);
        const detailsData = await detailsRes.json();

        setProject({ ...detailsData });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) return <p>Загрузка...</p>;
  if (error) return <p>{error}</p>;

  return (
    <main className={styles.main}>
      <div className={classnames(isMobile ? [styles.mainBackground, styles.mobile] : [styles.mainBackground])}>
        <img src={project.background} alt={project.name} />
      </div>

      <MainContainerLeftControl logoPosition="absolute" logoColor="white" widthAside={'350px'} data={<ProjectsAside />}>
        <h1 className={classnames(isMobile ? [styles.title, styles.mobile] : [styles.title])}>{project.name}</h1>

        {/* Основная информация о проекте */}
        <ProjectInfo props={project} />

        {/* Блоки с информацией и фото */}
        {project.project_content_blocks.length > 0 && <ProjectContentBlock props={project.project_content_blocks} />}

        {/* Технико-экономические показатели */}
        {project.technica_and_economic_indicators.length > 0 && (
          <ProjectEconomyIndicators props={project.technica_and_economic_indicators} />
        )}

        {/* Галерея изображений */}
        {project.project_photos.length > 0 && <ProjectPhotos props={project.project_photos} />}

        {/* Документы */}
        {project.project_documents.lenght > 0 && <ProjectDocuments props={project.project_documents} />}

        {/* Команда */}
        {project.command.length > 0 && <ProjectTeam props={project.command} />}
      </MainContainerLeftControl>
    </main>
  );
};

export default ProjectContent;
